// Phase 2 — 2FA stage extracted from Login.jsx. Handles both `2fa_setup`
// (initial enrollment with QR code) and `2fa_verify` (returning user
// entering a TOTP code). Pure presentational + form submit — state lives
// in the parent orchestrator.

import { ShieldCheck, ArrowLeft, Loader2 } from "lucide-react";
import { Banner, CodeInput, primaryBtn } from "./LoginShared";

export default function TwoFactorAuth({
  stage,            // "2fa_setup" | "2fa_verify"
  twofa,            // { qr, secret }
  code, setCode,
  busy,
  onVerify,
  onBack,           // only used in `2fa_verify`
  codeRef,
}) {
  if (stage === "2fa_setup") {
    return (
      <form onSubmit={onVerify} className="space-y-5" data-testid="twofa-setup-form">
        <Banner tone="amber" icon={ShieldCheck}>
          <b>First-time setup.</b> Scan the QR with Google Authenticator, Authy, or 1Password, then enter the 6-digit code to activate 2FA.
        </Banner>
        <div className="flex justify-center">
          {twofa.qr && (
            <div className="p-3 bg-white border border-[var(--line-2)] rounded-sm shadow-sm">
              <img src={twofa.qr} alt="2FA QR code" className="h-44 w-44" data-testid="twofa-qr" />
            </div>
          )}
        </div>
        <details className="text-[11.5px]">
          <summary className="cursor-pointer text-[var(--muted)] hover:text-[var(--ink)] transition-colors">
            Can't scan? Show secret key
          </summary>
          <div
            className="mt-2 font-mono text-[12px] bg-[var(--surface-2)] border border-[var(--line)] rounded-sm p-2.5 break-all"
            data-testid="twofa-secret"
          >
            {twofa.secret}
          </div>
        </details>
        <CodeInput value={code} onChange={setCode} ref={codeRef} />
        <button type="submit" disabled={busy} data-testid="twofa-confirm" className={primaryBtn}>
          {busy && <Loader2 size={14} className="animate-spin" />}
          Activate 2FA & sign in
        </button>
      </form>
    );
  }

  // stage === "2fa_verify"
  return (
    <form onSubmit={onVerify} className="space-y-5" data-testid="twofa-verify-form">
      <Banner tone="neutral" icon={ShieldCheck}>
        Open your authenticator app and enter the 6-digit code.
      </Banner>
      <CodeInput value={code} onChange={setCode} ref={codeRef} />
      <button type="submit" disabled={busy} data-testid="twofa-submit" className={primaryBtn}>
        {busy && <Loader2 size={14} className="animate-spin" />}
        Verify & sign in
      </button>
      <button
        type="button"
        onClick={onBack}
        data-testid="twofa-back"
        className="w-full text-center text-[12px] text-[var(--muted)] hover:text-[var(--ink)] transition-colors inline-flex items-center justify-center gap-1.5"
      >
        <ArrowLeft size={11} /> Back
      </button>
    </form>
  );
}
